/**
 * Service: historyApi
 */
angular.module('acme.common.service.historyApi', [
  'acme.common.factory.QueryStringBuilder',
  'acme.common.factory.apiVersion'
])
.service('HistoryApiService', [ '$http', 'QueryStringBuilderFactory', 'ApiVersionFactory', function($http, QueryStringBuilderFactory, ApiVersionFactory) {
    
    return {
      
      av_history: new ApiVersionFactory({
        url: '/v1/api/history',
        version: 'v2'
      }),
      
      init: function(endpoint) {
        return this;
      },

      list: function(id, path, props) {
        var qs,
            q = '';
                
        if (props) {
          qs = new QueryStringBuilderFactory({
            props: props,
            fields: {
              optional: ['type', 'pageSize', 'page', 'sortField', 'sortDirection', 'search']
            }
          });
          q = qs.query;
        }
        var url = this.av_history.url + '/' + path;
        if (path === "tenant/calendars") {
          //make exception for tenant calendar history api
          url = url.replace("v2", "v1");
        }
        if (id) {
          url += '/' + id;
        }
        return $http({
          method: 'get',
          url: url + q
        });
      },

      detail: function(id, path) {
        return $http({
          method: 'get',
          url: this.av_history.url + '/' + id
        });
      },
      
      auditTrail: {
        av_history: new ApiVersionFactory({
          url: '/v1/api/history',
          version: 'v2'
        }),
        
        list: function (version, id, path) {
          return $http({
            method: 'get',
            url: this.av_history.url + '/' + path  + '/' + id + '/diff/' + version
          });
        }
      }

    };

}]);